import makeStyles from '@mui/styles/makeStyles';

export const useStylesBedRequest = makeStyles((theme) => ({
    root: {
        backgroundColor: `${theme.palette.background.paper} !important`,
    },
    groupRoot: {
        marginBottom: 10,
        borderRadius: 5,
    },
    paper: {
        padding: 10,
        backgroundColor: theme.palette.background.default,
    },
    centerRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    userLog: {
        fontSize: 11,
        fontStyle: 'italic',
        color: theme.palette.mode === 'light' ? '#4B4B4B' : '#818181',
    },
    comment: {
        fontSize: 15,
        padding: '5px 10px',
        backgroundColor: theme.palette.background.default,
        borderRadius: 10,
        marginTop: 5,
    },
    clinician: {
        marginBottom: 10,
    },
    row: {
        width: '100%',
        marginBottom: 10,
    },
    divider: {
        margin: '10px 0',
    },
    wards: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 8,
        marginBottom: 10,
        '&.column': {
            flexDirection: 'column',
        },
    },
    iconButton: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: 8,
        '&.Mui-disabled': {
            borderColor: theme.palette.mode === 'light' ? '#eaeaea' : '#b2b2b2',
        },
    },
    box: {
        width: 20,
        height: 20,
        borderRadius: 4,
        backgroundColor: '#62ad6d',
        marginRight: 10,
        fontWeight: 'small',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&.occupied': {
            backgroundColor: '#bf4b5d',
        },
        '&.status': {
            backgroundColor: '#feb03a',
        },
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10',
        '&.separate': {
            justifyContent: 'space-between',
        },
    },
    statusBtn: {
        minWidth: 190,
        borderColor: '#ACAFB3',
        color: '#ACAFB3',
        '&.patient': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
        '&.ready': {
            borderColor: '#4EAC6F',
            color: '#4EAC6F',
        },
        '&.occupied': {
            borderColor: '#f7a202',
            color: '#f7a202',
        },
    },
    bedAllocation: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 10,
    },
}));